/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { CompositeSearchEnhancedFilterConditionType } from './CompositeSearchEnhancedFilterConditionType';

export type CompositeSearchEnhancedFilterJobSubFamily = {
    filterType: CompositeSearchEnhancedFilterJobSubFamily.filterType;
    conditionType: CompositeSearchEnhancedFilterConditionType;
    value: Array<number>;
};

export namespace CompositeSearchEnhancedFilterJobSubFamily {

    export enum filterType {
        JOB_SUB_FAMILY = 'jobSubFamily',
    }


}

